import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_CUISINES,
  REQUEST_CREATE_MASTER_CUISINES,
  SET_MASTER_CUISINES,
  SUCCESS_CREATE_MASTER_CUISINES,
  ERROR_GET_MASTER_CUISINES,
  ERROR_CREATE_MASTER_CUISINES,
  SET_MESSAGE_MASTER_CUISINES,
  SUCCESS_DELETE_MASTER_CUISINES,
  SUCCESS_UPDATE_MASTER_CUISINES,
  REQUEST_DELETE_MASTER_CUISINES,
  REQUEST_UPDATE_MASTER_CUISINES,
  ERROR_DELETE_MASTER_CUISINES,
  ERROR_UPDATE_MASTER_CUISINES,
  REQUEST_MASTER_CUISINES_CATEGORIES,
  SET_MASTER_CUISINES_CATEGORIES,
  ERROR_GET_MASTER_CUISINES_CATEGORIES,
} from "./cuisineActionTypes";

function* requestMasterCuisines(action: Record<string, any>): any {
  try {
    const result: any = yield call(getCuisinesMaster);
    yield put({ type: SET_MASTER_CUISINES, payload: result.data.data });
    // console.log(result.data);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_CUISINES, payload: message });
  }
}

function* requestMasterCuisinesCat(action: Record<string, any>): any {
  try {
    const result: any = yield call(getCuisinesMaster);
    yield put({
      type: SET_MASTER_CUISINES_CATEGORIES,
      payload: result.data.data.categories,
    });
    // console.log(result.data);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_CUISINES_CATEGORIES, payload: message });
  }
}

function* requestUpdateMasterCuisines(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterCuisines,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_CUISINES,
      payload: result.data.data,
    });
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_CUISINES, payload: message });
  }
}

function* requestDeleteMasterCuisines(action: Record<string, any>): any {
  try {
    yield call(deleteMasterCuisines, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_CUISINES,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_CUISINES, payload: message });
  }
}

function* requestCreateMasterCuisines(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterCuisines, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_CUISINES,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_CUISINES, payload: message });
  }
}

export function getCuisinesMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/cuisine`,
    withCredentials: true,
  });
}

export function createMasterCuisines(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/cuisine`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterCuisines(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/cuisine/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterCuisines(
  payload: Record<string, any>,
  _id: string
) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/cuisine/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const cuisinesMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_CUISINES, requestMasterCuisines),
    takeLatest(REQUEST_MASTER_CUISINES_CATEGORIES, requestMasterCuisinesCat),
    takeLatest(REQUEST_CREATE_MASTER_CUISINES, requestCreateMasterCuisines),
    takeLatest(REQUEST_UPDATE_MASTER_CUISINES, requestUpdateMasterCuisines),
    takeLatest(REQUEST_DELETE_MASTER_CUISINES, requestDeleteMasterCuisines),
  ]);
};

export default cuisinesMasterSaga;
